export default {
  // Page titles
  title: "โควตาตัวอย่าง",
  detailTitle: "รายละเอียดโควตาตัวอย่าง",

  // Table columns
  shopInfo: "ข้อมูลร้านค้า",
  supplierName: "ห่วงโซ่อุปทาน",
  activeProductCount: "จำนวนสินค้าที่ใช้งานอยู่",
  quotaLessThan30: "โควตา ≤ 30",
  quotaEqualsZero: "โควตา = 0",
  follower: "PC ร้านค้า",
  activeProducts: "สินค้าที่ใช้งานอยู่",
  view: "ดู",

  // Detail table
  productInfo: "ข้อมูลสินค้า",
  activityInfo: "ข้อมูลกิจกรรม",
  remainingQuota: "โควตาที่เหลือ",
  activityId: "รหัสกิจกรรม",
  copySuccess: "คัดลอกลิงก์กิจกรรมแล้ว",
  copyLink: "คัดลอกลิงก์กิจกรรม",
  zeroQuotaWarning: "การสมัครถูกจำกัด ติดต่อร้านค้าเพื่อเติมโควตาตัวอย่าง!",
  lowQuotaWarning: "โควตาเหลือน้อย ติดต่อร้านค้าเพื่อเติมโควตาตัวอย่าง!",

  // Search form
  shopName: "ชื่อร้านค้า",
  shopCode: "รหัสร้านค้า",
  inputShopName: "กรุณาใส่ชื่อร้านค้า",
  inputShopCode: "กรุณาใส่รหัสร้านค้า",
  inputSupplierName: "กรุณาใส่ชื่อห่วงโซ่อุปทาน",
  selectFollower: "กรุณาเลือก PC ร้านค้า",

  // Others
  onlyShowLowQuota: "แสดงเฉพาะร้านค้าที่ต้องการเติมโควตา",

  // Alert messages
  alertMessage: "สินค้าที่มีโควตาตัวอย่างเป็นศูนย์ไม่สามารถสมัครขอตัวอย่างได้",
  alertDescription: "โปรดแจ้งร้านค้าให้เติมโควตาโดยด่วน",
  howToReplenish: "วิธีการเติมโควตา?"
};
